import * as z from "zod";
import { userFacingError } from "../authorization";
import { mutator } from "./mutator";

export const deleteServiceAccountFederationSchema = z.object({
  id: z.string(),
});

// Removing a trusted issuer mapping. Gated on service_account:manage for the
// account the federation belongs to. The federation is resolved first so the
// permission check runs against its owning service account.
export const deleteServiceAccountFederation = mutator({
  schema: deleteServiceAccountFederationSchema,
  resolve: {
    federation: { kind: "serviceAccountFederation", from: "id" },
  },
  permissions: [
    {
      permission: "service_account:manage",
      scopeId: ({ args }) => args.federation.serviceAccountId,
    },
  ],
  fn: async ({ tx, args: { federation } }) => {
    if (!federation) throw userFacingError("Federation not found");
    await tx.mutate.serviceAccountFederations.delete({ id: federation.id });
  },
});
